import { STATES_GATE_STATE_OPEN, STATES_GATE_STATE_FULLY_OPEN, STATES_GATE_STATE_CLOSED, STATES_TREND_RISING } from '../../../lambdas/common/const.js';

export function determineLevelAboveBelow(t, site, lastValue) {
  if (lastValue == undefined || lastValue == {} || site?.properties?.capacity === undefined) {
    return undefined;
  }
  
  const damLevelAboveBelow = lastValue - site.properties.capacity;
  let damLevelCapacityStat = '';
  if (damLevelAboveBelow > 0) {
    damLevelCapacityStat = t(`levels.above_benchmark`, {
      count: damLevelAboveBelow,
      value: Math.abs(damLevelAboveBelow).toFixed(2),
      units: t(`units.${site.properties.unit}.label`),
      unit: t(`units.${site.properties.unit}.label_singular`),
      benchmark: 'capacity' });
  } else if (damLevelAboveBelow < 0) {
    damLevelCapacityStat = t(`levels.below_benchmark`, {
      count: damLevelAboveBelow,
      value: Math.abs(damLevelAboveBelow).toFixed(2),
      units: t(`units.${site.properties.unit}.label`),
      unit: t(`units.${site.properties.unit}.label_singular`),
      benchmark: 'capacity' });
  } else {
    damLevelCapacityStat = t(`levels.equal_benchmark`, {
      count: damLevelAboveBelow,
      value: Math.abs(damLevelAboveBelow).toFixed(2),
      units: t(`units.${site.properties.unit}.label`),
      unit: t(`units.${site.properties.unit}.label_singular`),
      benchmark: 'capacity' });
  }

  return damLevelCapacityStat
}

export function determineDischarge(t, site, lastValue, state) {
  const dischargeProfile = site?.properties?.dischargeProfile;
  if (lastValue === undefined || lastValue === '' || dischargeProfile === undefined) {
    return { gateState: undefined, dischargeRate: undefined };
  }

  let gateState = STATES_GATE_STATE_CLOSED;
  let dischargeRate = 0;

  const dischargeLevel = Object.keys(dischargeProfile).reduce((lastLevel, level) => {
    const parsedLevel = parseFloat(level);
    const parsedLastLevel = parseFloat(lastLevel);
    if (parsedLevel > parsedLastLevel && parsedLevel <= lastValue) {
      return level;
    } else {
      return lastLevel;
    }
  });

  const dischargeEntry = dischargeProfile[dischargeLevel];

  if (dischargeEntry) {
    if (dischargeEntry.GatesOpenFully) {
      gateState = STATES_GATE_STATE_FULLY_OPEN;
    } else if (dischargeEntry.GatesOpen) {
      gateState = STATES_GATE_STATE_OPEN;
    }
    if (state?.trend === STATES_TREND_RISING) {
      dischargeRate = dischargeEntry.DischargeRising;
    } else {
      dischargeRate = dischargeEntry.DischargeFalling;
    }
  }

  return { gateState, dischargeRate };
}

export function determineStorage(t, site, lastValue) {
  const storageProfile = site?.properties?.storageData;
  
  if (lastValue === undefined || lastValue === '' || storageProfile === undefined) {
    return { percent: undefined, volume: undefined };
  }

  console.log(Object.keys(storageProfile), lastValue)
  
  const storageLevel = Object.keys(storageProfile).reduce((lastLevel, level) => {
    const parsedLevel = parseFloat(level);
    const parsedLastLevel = parseFloat(lastLevel);
    if(parsedLevel > parsedLastLevel && parsedLevel <= lastValue) {
      return level; 
    } else {
      return lastLevel;
    }
  })
  
  console.log(storageLevel)
  return storageProfile[storageLevel];
}
